export const ENTITY_TYPE_TAG: string = 'tag';
export const ENTITY_TYPE_FILE: string = 'file';
export const ENTITY_TYPE_ASSET: string = 'asset';
export const ENTITY_TYPE_ASSET_PHOTO: string = 'asset-photo';
export const ENTITY_TYPE_ASSET_ALLOCATION_ITEM: string = 'asset-allocation-item';
export const ENTITY_TYPE_ASSET_SELLER: string = 'asset-seller';
export const ENTITY_TYPE_ASSET_TYPE: string = 'asset-type';
export const ENTITY_TYPE_ASSET_TAG: string = 'asset-tag';
export const ENTITY_TYPE_PORTFOLIO: string = 'portfolio';
export const ENTITY_TYPE_PORTFOLIO_GROUP: string = 'portfolio-group';
export const ENTITY_TYPE_PORTFOLIO_MARKER_COLOR: string = 'portfolio-marker-color';
export const ENTITY_TYPE_ACTIVITY: string = 'activity';
export const ENTITY_TYPE_ACTIVITY_TAG: string = 'activity-tag';
export const ENTITY_TYPE_ACTIVITY_DEAL_CONTACT: string = 'activity-deal-contact';
export const ENTITY_TYPE_CONTACT: string = 'contact';
export const ENTITY_TYPE_CONTACT_TO_CONTACT_GROUP: string = 'contact-to-contact-group';
export const ENTITY_TYPE_CONTACT_GROUP: string = 'contact-group';
export const ENTITY_TYPE_CONTACT_ASSET_TYPE: string = 'contact-asset-type';
export const ENTITY_TYPE_CONTACT_ADDRESS: string = 'contact-address';
export const ENTITY_TYPE_CONTACT_TAG: string = 'contact-tag';
export const ENTITY_TYPE_DEAL: string = 'deal';
export const ENTITY_TYPE_DEAL_PHOTO: string = 'deal-photo';
export const ENTITY_TYPE_DEAL_OPTIONS: string = 'deal-options';
export const ENTITY_TYPE_DEAL_SPONSOR: string = 'deal-sponsor';
export const ENTITY_TYPE_DEAL_BROKER: string = 'deal-broker';
export const ENTITY_TYPE_DEAL_LENDER: string = 'deal-lender';
export const ENTITY_TYPE_DEAL_CONTACT_GROUP: string = 'deal-contact-group';
export const ENTITY_TYPE_DEAL_CONTACT: string = 'deal-contact';
export const ENTITY_TYPE_DEAL_MILESTONE: string = 'deal-milestone';
export const ENTITY_TYPE_DEAL_EXTERNAL_LINK: string = 'deal-external-link';
export const ENTITY_TYPE_DEAL_CUSTOM_SECTION_GROUP: string = 'deal-custom-section-group';
export const ENTITY_TYPE_DEAL_CUSTOM_SECTION_FIELD: string = 'deal-custom-section-field';
export const ENTITY_TYPE_DEAL_CUSTOM_LIST_TYPE: string = 'deal-custom-list-type';
export const ENTITY_TYPE_DEAL_CUSTOM_LIST_TYPE_OPTION: string = 'deal-custom-list-type-option';
export const ENTITY_TYPE_DEAL_TOP_LEVEL_METRICS_ITEM: string = 'deal-top-level-metrics-item';
export const ENTITY_TYPE_DEAL_HISTORICAL_VALUATIONS_ITEM: string = 'deal-historical-valuations-item';
export const ENTITY_TYPE_DEAL_INVESTMENT_RETURNS_ITEM: string = 'deal-investment-returns-item';
export const ENTITY_TYPE_DEAL_METRICS_STATISTICS_GROUP: string = 'deal-metrics-statistics-group';
export const ENTITY_TYPE_DEAL_METRICS_STATISTICS_ITEM: string = 'deal-metrics-statistics-item';
export const ENTITY_TYPE_DEAL_METRICS_CAPITAL_STACK_ITEM: string = 'deal-metrics-capital-stack-item';
export const ENTITY_TYPE_DEAL_CAPITALIZATION: string = 'deal-capitalization';
export const ENTITY_TYPE_DEAL_BUILDING_DETAILS: string = 'deal-building-details';
export const ENTITY_TYPE_DEAL_EQUITY_ORGANIZATION_CHART: string = 'deal-equity-organization-chart';
export const ENTITY_TYPE_DEAL_CAPITALIZATION_GROUP: string = 'deal-capitalization-group';
export const ENTITY_TYPE_DEAL_CAPITALIZATION_ITEM: string = 'deal-capitalization-item';
export const ENTITY_TYPE_DEAL_ASSET_USE_BREAKDOWN_ITEM: string = 'deal-asset-use-breakdown-item';
export const ENTITY_TYPE_DEAL_ASSET_USE_BREAKDOWN_PROPERTY: string = 'deal-asset-use-breakdown-property';
export const ENTITY_TYPE_DEAL_ASSET_USE_BREAKDOWN_HEADER: string = 'deal-asset-use-breakdown-header';
export const ENTITY_TYPE_DEAL_TERM: string = 'deal-term';
export const ENTITY_TYPE_DEAL_TERM_GROUP: string = 'deal-term-group';
export const ENTITY_TYPE_DEAL_TASK: string = 'deal-task';
export const ENTITY_TYPE_DEAL_TASK_GROUP: string = 'deal-task-group';
export const ENTITY_TYPE_DEAL_TASK_REVIEW: string = 'deal-task-review';
export const ENTITY_TYPE_DEAL_TASK_CONTACT: string = 'deal-task-contact';
export const ENTITY_TYPE_DEAL_FILE: string = 'deal-file';
export const ENTITY_TYPE_DEAL_FILE_GROUP: string = 'deal-file-group';
export const ENTITY_TYPE_DEAL_PARTICIPANT: string = 'deal-participant';
export const ENTITY_TYPE_DEAL_PARTICIPANT_GROUP: string = 'deal-participant-group';
export const ENTITY_TYPE_DEAL_SCHEDULE: string = 'deal-schedule';
export const ENTITY_TYPE_DEAL_SCHEDULE_TASK: string = 'deal-schedule-task';
export const ENTITY_TYPE_DEAL_SCHEDULE_TASK_LINK: string = 'deal-schedule-task-link';
export const ENTITY_TYPE_USER: string = 'user';
export const ENTITY_TYPE_USER_ASSET_TYPE: string = 'user-asset-type';
export const ENTITY_TYPE_ACCOUNT_USER: string = 'account-user';
export const ENTITY_TYPE_ACCOUNT_USER_DEAL: string = 'account-user-deal';
export const ENTITY_TYPE_ACCOUNT_USER_PORTFOLIO: string = 'account-user-portfolio';
export const ENTITY_TYPE_ACCOUNT_USER_DEAL_ACCESS_LEVEL: string = 'account-user-deal-access-level';
